import React from 'react'
import { Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { useStyles } from './InvalidAuthPage.styles'

interface InvalidAuthPageProps {
  message?: string
}

export const InvalidAuthPage: React.FC<InvalidAuthPageProps> = ({
  message,
}) => {
  const { classes } = useStyles()

  const defaultMessage =
    'Unable to authenticate your request. The authentication token is missing or invalid.'

  return (
    <div className={classes.root} data-testid="invalid-auth-page">
      <ErrorOutlineIcon className={classes.icon} />
      <Typography variant="h5" className={classes.title}>
        Authentication Failed
      </Typography>
      <Typography variant="body1" className={classes.message}>
        {message || defaultMessage}
      </Typography>
      <Typography variant="body2" className={classes.supportMessage}>
        Please contact your administrator for assistance.
      </Typography>
    </div>
  )
}
